import React from 'react';
import Portal from './Portal';

// A question with two answers, for the one thing V3 does to a customer's machine from a button. It says what will happen and where; nothing happens
// until the person answers it.
export default function ConfirmDialog({ title, children, confirmLabel, busy = false, onConfirm, onCancel }) {
  return (
    <Portal><div className="dialog-host">
      <div className="dialog" role="dialog" aria-label={title}>
        <h2>{title}</h2>
        <div className="dialog-text">{children}</div>
        <div className="dialog-actions">
          <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={onCancel}>Cancel</button>
          <button type="button" className="btn btn-primary btn-sm" disabled={busy} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div></Portal>
  );
}
